export enum ERegion {
  US = "US",
  EMEA = "EMEA",
  AUS = "AUS",
  APAC = "APAC"
}
